var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{ref:"floatBar",staticClass:"floatBar"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"floatMargin",style:({
      '--height': `${_vm.floatHeight}px`,
    })})])
}
var staticRenderFns = []

export { render, staticRenderFns }